import { z } from 'zod/v4';

export interface PCBCredentialsDTO extends z.infer<typeof PCBCredentialsDTORuntype> {}

export enum WuerthRegionEnum {
    International = 'International',
    Austria = 'Austria',
    Belgium = 'Belgium',
    France = 'France',
    Germany = 'Germany',
    Ireland = 'Ireland',
    Italy = 'Italy',
    Netherlands = 'Netherlands',
    Poland = 'Poland',
    Portugal = 'Portugal',
    Spain = 'Spain',
    Sweden = 'Sweden',
    UnitedKingdom = 'UnitedKingdom',
    Switzerland = 'Switzerland',
}

export type WuerthRegion = z.infer<typeof WuerthRegionRuntype>;
export const WuerthRegionRuntype = z.enum([
    WuerthRegionEnum.International,
    WuerthRegionEnum.Austria,
    WuerthRegionEnum.Belgium,
    WuerthRegionEnum.France,
    WuerthRegionEnum.Germany,
    WuerthRegionEnum.Ireland,
    WuerthRegionEnum.Italy,
    WuerthRegionEnum.Netherlands,
    WuerthRegionEnum.Poland,
    WuerthRegionEnum.Portugal,
    WuerthRegionEnum.Spain,
    WuerthRegionEnum.Sweden,
    WuerthRegionEnum.Switzerland,
    WuerthRegionEnum.UnitedKingdom,
]);

export const PCBCredentialsDTORuntype = z.object({
    username: z.string(),
    region: WuerthRegionRuntype.nullable(),
    is_valid: z.boolean(),
    error: z.string().nullable(),
});

export interface UserPasswordPCBCredentialsInputDTO extends z.infer<typeof UserPasswordCredentialsInputDTORuntype> {}

export const UserPasswordCredentialsInputDTORuntype = z.object({
    username: z.string(),
    password: z.string(),
});
